import { downloadBlob } from './repertorioShareQr';

function safeFilenamePart(value) {
  return (String(value || 'pagina')
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_')
    .replace(/\s+/g, '_')
    .slice(0, 80) || 'pagina');
}

function extFromUrl(url) {
  try {
    const path = new URL(url, window.location.origin).pathname;
    const match = path.match(/\.(jpe?g|png|webp|gif)$/i);
    return match ? `.${match[1].toLowerCase()}` : '.jpg';
  } catch {
    return '.jpg';
  }
}

function mimeFromExt(ext) {
  if (ext === '.png') return 'image/png';
  if (ext === '.webp') return 'image/webp';
  if (ext === '.gif') return 'image/gif';
  return 'image/jpeg';
}

async function fetchImageBlob(imagenUrl) {
  const res = await fetch(imagenUrl, { credentials: 'include' });
  if (!res.ok) throw new Error('No se pudo obtener la imagen de la página');
  return res.blob();
}

function loadImageFromBlob(blob) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('No se pudo cargar la imagen de la página'));
    };
    img.src = objectUrl;
  });
}

/**
 * Descarga una página de partitura aplicando la rotación guardada.
 * @param {{ imagenUrl: string, rotacion?: number, obraTitulo?: string, orden?: number }} params
 */
export async function downloadPartituraPaginaImage({ imagenUrl, rotacion = 0, obraTitulo, orden }) {
  if (!imagenUrl) throw new Error('La página no tiene imagen');

  const blob = await fetchImageBlob(imagenUrl);
  const rot = ((Number(rotacion) % 360) + 360) % 360;

  if (!rot) {
    const ext = extFromUrl(imagenUrl);
    const base = safeFilenamePart(obraTitulo || 'obra');
    const suffix = orden != null ? `_pagina_${orden}` : '_pagina';
    downloadBlob(blob, `${base}${suffix}${ext}`);
    return;
  }

  const img = await loadImageFromBlob(blob);
  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('No se pudo preparar la descarga');

  if (rot === 90 || rot === 270) {
    canvas.width = h;
    canvas.height = w;
  } else {
    canvas.width = w;
    canvas.height = h;
  }

  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((rot * Math.PI) / 180);
  ctx.drawImage(img, -w / 2, -h / 2);

  const ext = extFromUrl(imagenUrl);
  const mime = mimeFromExt(ext);
  const rotatedBlob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('No se pudo generar el archivo'))),
      mime,
      mime === 'image/jpeg' ? 0.92 : undefined,
    );
  });

  const base = safeFilenamePart(obraTitulo || 'obra');
  const suffix = orden != null ? `_pagina_${orden}` : '_pagina';
  downloadBlob(rotatedBlob, `${base}${suffix}${ext}`);
}
